import { useContext, useSyncExternalStore } from "react"
import { LayerGroup } from "react-leaflet"
import { PlayerMarker } from "./PlayerMarker"
import { AuthProvider } from "../globalContext"
import { dynamicPositionStore } from "./dynamicPositionStore"

export function SelfLayer(){
    const entryProvider = useSyncExternalStore(dynamicPositionStore.subscribeNewEntry, dynamicPositionStore.getPlayersIds)
    const {id: userID} = useContext(AuthProvider)

    return (
    <LayerGroup>
        {
            entryProvider.filter((v) => v === userID).map((id) =>{
                return <PlayerMarker id={userID} key={`p-${id}`} color="#dc143c" showLastSeenInfo={false} />
            })
        }
    </LayerGroup>
    )
}